import React from "react";
import { connect } from "react-redux";

import {FormattedMessage, injectIntl} from "react-intl";
import {getQuoteDisplayName} from "../../../../misc/quotesFunctions";
import LookListMainFeature from "../../list/lookListMainFeature";
import {featureIsBundle} from "../../lookNavigation/lookFunctions2";
import GroheCartDisclaimer from "./groheCartDisclaimer";
import {CART_ITEM_ADDED_BY} from "../../../shoppingCart/cartItemInterface";
import {IS_PRODUCT_JOURNEY} from "../../../../config";

const GroheCartContent = (props) => {

  const {cartItems, quotes, intl, fabricatorData} = props;

  return (
    <div className="gc-main">
      {quotes.map((quote, quoteIndex) => {

        const cartItemsList = cartItems
          .filter(cItem => IS_PRODUCT_JOURNEY
            ? cItem.addedBy === CART_ITEM_ADDED_BY.user && !cItem.relatedProductParent
            : !cItem.relatedProductParent)
          .sort((a, b) => featureIsBundle(a.cartFeature, cartItems) - featureIsBundle(b.cartFeature, cartItems))

        if (!cartItemsList.length) {
          // if (!cartItems.length || (Object.keys(quotesList).every(quoteIndex => !quotesList[quoteIndex].length))) {
          return (
            <div className="gc-section" key={"quote" + quoteIndex}>
              <h3 className="gc-header__sub-title text-center" key={"quote" + quoteIndex}>
                <FormattedMessage id="grohe.cart.noCartItems"/>
              </h3>
            </div>
          )
        }

        return (
          <div className="gc-section" key={"quote" + quoteIndex}>
            <h4 className="grohe-same__list-section-title">
              {getQuoteDisplayName(quoteIndex, cartItems, quotes, intl.messages, intl.locale, fabricatorData)}
            </h4>
            <ul className="gc-section__list">
              {cartItemsList.map(cartItem => {
                return <LookListMainFeature cartItem={cartItem} key={cartItem.id}/>
              })}
            </ul>
            <GroheCartDisclaimer/>
          </div>
        )
      })}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {quotes, activeQuoteIndex} = store.quotesState;
  const {cartItems} = store.cartState;
  const fabricatorData = store.fabricatorState;

  return {
    quotes,
    activeQuoteIndex,
    cartItems,
    fabricatorData,
  };
};

export default injectIntl(
  connect(mapStateToProps)(GroheCartContent)
)
